import { type InjectionKey, inject } from 'vue';

export const CountriesManagerInjectionKey = Symbol('CountriesManagerInjectionKey') as InjectionKey<CountriesManager>;

export class CountriesManager {
  private implicit: string[];

  constructor(implicit: string[]) {
    this.implicit = implicit;
  }

  public isImplicit(country: string | null | undefined) {
    if (country) {
      return this.implicit.includes(country);
    }

    return false;
  }

  public isExplicit(country: string | null | undefined) {
    return !this.isImplicit(country);
  }
}

export function useCountriesManager() {
  return inject(CountriesManagerInjectionKey)!;
}
